<template>
  <v-container>
    <div id="headersMelhoresClientes">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Cliente
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Vendedor
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Fat. Acumu. do Ano Anterior
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Faturamento Anual Acumulado
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Variação de Fat. Anual Acumu.
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in clientesMaiorCrescimento"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome_cliente }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.vendedor }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento_anterior }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.faturamento }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                  :style="getColor()"
                >
                  {{ item.variacao }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <router-link
          to="/somenteclientes/detalhe-cliente-dados-maiores-crescimento"
          :style="styleObject"
          class="text-center"
        >
          <div
            id="linkDetalheClienteDadosMaioresCrescimento"
            class="text-center"
          >
            <v-icon
              id="iconLinkClienteDadosMaioresCrescimento"
              class="text-center"
            >
              mdi-chevron-double-down
            </v-icon><br>
          </div>
        </router-link>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../services/somentecliente'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowClientesExibicaoMelhores',
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      headersClientesMelhoresPiores: [
        { text: 'Cliente', value: 'nome_cliente', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', class: 'black--text title' },
        { text: 'Fat. Acumu. do Ano Anterior', value: 'faturamento_anterior', align: 'right', class: 'black--text title' },
        { text: 'Faturamento Anual Acumulado', value: 'faturamento', align: 'right', class: 'black--text title' },
        { text: 'Variação de Fat. Anual Acumu.', value: 'variacao', align: 'right', class: 'black--text title' },
      ],
      clientesMaiorCrescimento: [],
      vendedores: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      linhaProducao: [],
      cidades: [],
      clientes: [],
    }),

    created () {
      eventEmit.$on('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set_faturamento_novos_clientes', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, area, rede, supervisor, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedores = vendedores
        this.area = area
        this.rede = rede
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao
        this.cidades = cidades
        this.clientes = clientes

        this.showDadosClientesMaioresCrescimento()
      },

      async showDadosClientesMaioresCrescimento () {
        this.loading = true
        this.clientesMaiorCrescimento = []

        await Clientes.showClienteMaioresCrescimento(this.primeiroDia, this.ultimoDia, this.select, this.vendedores, localStorage.tokencontrato, this.area, this.rede, this.supervisor, this.receita, this.segmento, this.categoria, this.promotor, this.classificacao, this.linhaProducao, this.cidades, this.clientes).then(resposta => {
          if (resposta.data.status) {
            this.clientesMaiorCrescimento = resposta.data.dadosMaioresClientes.map((item) => {
              var listaMelhoresClientes = ({
                nome_cliente: item.nome_cliente,
                vendedor: item.vendedor,
                faturamento_anterior: item.faturamento_anterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                faturamento: item.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                variacao: item.variacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
              })

              return listaMelhoresClientes
            })
          } else if (resposta.data.msg === 'Não há dados de faturamento para clientes no ano corrente') {
            this.clientesMaiorCrescimento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Não há dados de faturamento para clientes no ano anterior') {
            this.clientesMaiorCrescimento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Não há dados de clientes com crescimento do faturamento em comparativo com o ano anterior') {
            this.clientesMaiorCrescimento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      getColor () {
        return 'color: green'
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersMelhoresClientes {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersMelhoresClientes {
      width: 100% !important;
    }
  }

  @media screen
  and (min-width : 1200px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersMelhoresClientes {
      width: 92% !important;
    }
  }

  #textotabela {
    font-size: 0.75rem !important
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
